import AFSLogo from '@/assets/branding/afs/AITF-LOGO.png';

const colors = {
  // Brand colors
  brand_primary: '#8FC542',
  brand_primary_hover: '#6FA336',
  brand_primary_highlight: '#C8E59A',
  brand_primary_mid: '#A4D363',
  brand_primary_dark: '#456122',
  brand_secondary: '#5F7D2B',
  brand_accent_start: '#7ab733',
  brand_accent_end: '#3F7AC8',
  brand_accent_light_start: '#f2fbe8',
  brand_accent_light_end: '#DCE8FF',
  brand_complementary_accent: 'rgb(127,62,221)',
  brand_auth_gradient_mid: '#5F7D2B',
  brand_auth_gradient_end: '#456122',
  brand_auth_warp_mid: '#A4D363',
};

export default {
  name: 'Assistiv',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AFSLogo,
  colors,
};
